import { environment } from "@env/environment";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class UsersService {
    constructor(http) {
        this.http = http;
        this.PROFILE_CODS = [
            { id: "student", description: "Estudante" },
            { id: "teacher", description: "Professor" },
        ];
    }
    getGuests(param = "") {
        return this.http.get(`${environment.base_url}/users/find_email?param=${param}`);
    }
    userAlreadyExists(email) {
        return this.http.get(`${environment.base_url}/users/already_exists?param=${email}`);
    }
    getUserAccess(userId) {
        return this.http.get(`${environment.base_url}/users/${userId}/access/count`);
    }
    updateResearchProfileType(userId, profileType) {
        return this.http.put(`${environment.base_url}/users/${userId}/update_profile_type`, { profile_type: profileType });
    }
    updateWordsCount(userId, words) {
        return this.http.put(`${environment.base_url}/users/${userId}/update_words_count`, { words: words });
    }
    getWordsCount(userId) {
        return this.http.get(`${environment.base_url}/users/${userId}/get_words_count`);
    }
    getInvitationCode(userId) {
        return this.http.get(`${environment.base_url}/users/${userId}/get_invitation_code`);
    }
    getExtract(userId, per_page = 10, page = 1) {
        return this.http.get(`${environment.base_url}/users/${userId}/extract_admin?page=${page}&per_page=${per_page}`);
    }
    pixRequest(formData) {
        return this.http.post(`${environment.base_url}/users/pix_request`, formData);
    }
    updateAttending(userId, attending) {
        return this.http.put(`${environment.base_url}/users/${userId}/update_attending`, { attending: attending });
    }
    getUserId() {
        return this.http.get(`${environment.base_url}/users/get_user_id`);
    }
    getUserWordsById(userId) {
        return this.http.get(`${environment.base_url}/users/${userId}/get_user_words_count`);
    }
}
UsersService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UsersService_Factory() { return new UsersService(i0.ɵɵinject(i1.HttpClient)); }, token: UsersService, providedIn: "root" });
